import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Status } from "../singleCase/types/Case";
import { Consent } from "./types/Consent";

export interface ConsentState {
  loading: boolean;
  error: string;
  consent: Consent;
}

const initialState: ConsentState = {
  loading: false,
  error: "",
  consent: {
    caseId: "",
    caseStatus: Status.INITIAL,
    consentGiven: false,
  },
};

interface GiveConsentRequest {
  caseId: string;
}

const consentSlice = createSlice({
  name: "consent",
  initialState,
  reducers: {
    requestGiveConsent: (
      state,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      action: PayloadAction<GiveConsentRequest>,
    ) => {
      state.loading = true;
    },
    requestGiveConsentSuccessful: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.error = "";
      state.consent.consentGiven = action.payload;
    },
    requestGiveConsentFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { actions } = consentSlice;
export default consentSlice.reducer;
